import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiClient, tokenManager } from '@/lib/api';

export default function SchoolmsLaunchPage() {
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const code = params.get('code') || '';

  useEffect(() => {
    if (!code) {
      setError('Missing launch code.');
      return;
    }
    let cancelled = false;
    apiClient.exchangeSchoolms(code).then((response) => {
      if (cancelled) return;
      if (response.success && response.data?.access && response.data.user) {
        tokenManager.setTokens({
          access: response.data.access,
          refresh: response.data.refresh,
          user: response.data.user,
        });
        window.location.assign('/dashboard');
        return;
      }
      setError(response.error || 'Could not open Learning.');
    });
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow">
        <h1 className="text-lg font-semibold text-slate-900">Opening Learning</h1>
        {error ? (
          <p className="mt-3 text-sm text-red-600">{error}</p>
        ) : (
          <p className="mt-3 text-sm text-slate-500">Signing you in from your school…</p>
        )}
      </div>
    </div>
  );
}
